"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaceMeh = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FaceMeh = _ref => {
  let {
    spotColor = "#FEB43D",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 37"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "face_pineapple_meh_svg__a",
    d: "M0 0h37v37H0z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "face_pineapple_meh_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#face_pineapple_meh_svg__a"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M1 18.5C1 28.15 8.85 36 18.5 36S36 28.15 36 18.5 28.15 1 18.5 1 1 8.85 1 18.5Z",
    mask: "url(#face_pineapple_meh_svg__b)",
    opacity: 0.5
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "M18.5 0C28.701 0 37 8.299 37 18.5 37 28.7 28.701 37 18.5 37 8.3 37 0 28.7 0 18.5 0 8.299 8.3 0 18.5 0Zm0 1.518C9.138 1.518 1.52 9.136 1.52 18.5c0 9.363 7.619 16.981 16.981 16.981 9.364 0 16.982-7.618 16.982-16.981 0-9.364-7.618-16.982-16.982-16.982Zm6.675 20.067a.82.82 0 0 1 1.051.485.82.82 0 0 1-.485 1.05l-13.558 4.996a.822.822 0 0 1-1.05-.484.82.82 0 0 1 .484-1.051ZM12.657 9.771c.803 0 1.656.582 1.656 1.66 0 1.077-.853 1.658-1.656 1.658-.424 0-.823-.147-1.126-.416-.343-.305-.532-.747-.532-1.242 0-1.078.854-1.66 1.658-1.66Zm12.445 0c.805 0 1.66.582 1.66 1.66 0 1.077-.855 1.658-1.66 1.658-.424 0-.823-.147-1.126-.416-.344-.304-.533-.746-.533-1.242 0-1.078.854-1.66 1.659-1.66ZM12.657 11.05c-.142 0-.38.05-.38.381 0 .33.238.38.38.38.14 0 .378-.05.378-.38 0-.13-.035-.226-.105-.288a.419.419 0 0 0-.273-.093Zm12.445 0c-.142 0-.38.05-.38.381 0 .33.238.38.38.38.142 0 .38-.05.38-.38 0-.13-.035-.226-.105-.288a.418.418 0 0 0-.275-.093Z",
    mask: "url(#face_pineapple_meh_svg__b)"
  })));
};
exports.FaceMeh = FaceMeh;
FaceMeh.displayName = "FaceMeh";